import Highlight from "../components/highlight";
import Lightbox from "../components/lightbox";

class Default {
  beforeEnter(data) {
    const scope = data.next.container;
    this.initHighlight(scope);
    this.initLightbox(scope);
  }

  afterEnter(data) {
    this.runGA();
    this.refreshScrollTriggers();
  }

  beforeLeave(data) {
    window._header.hamburger.close();
    // smooth scroll to top
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    window._header.resetFlyoutPosition(0);
  }

  afterLeave(data) {
    this.killScrollTriggers();
  }

  initHighlight = (scope) => {
    const $highlights = $(scope).find('[data-highlight="el"]');

    $highlights.each((i, el) => {
      new Highlight($(el));
    });
  };

  killScrollTriggers = () => {
    if (window._ScrollTrigger) {
      const allTrigger = window._ScrollTrigger.getAll();
      for (let i = 0; i < allTrigger.length; i++) {
        allTrigger[i].kill(true);
      }
    }
  };

  refreshScrollTriggers = () => {
    if (window._ScrollTrigger) {
      window._ScrollTrigger.refresh(true);
    }
  };

  initLightbox = (scope) => {
    const $lightbox = $(scope).find('[data-lightbox="el"]');

    $lightbox.each((i, el) => {
      new Lightbox($(el));
    });
  };

  runGA = () => {
    if (typeof gtag === "function") {
      const path = window.location.href
        .replace(window.location.origin, "")
        .toLowerCase();
      gtag("js", new Date());
      gtag("config", "UA-64065520-1", {
        page_title: document.title,
        page_path: path,
      });
    }
  };
}

export default Default;
